import { ApiService } from "../_services";

const getProfileById = (id: number) => {
  const client = new ApiService();
  const path = `/profiles?userId=${id}`;

  client.setAuthHeader();
  return client.get(path)
    .then(response => {
      if (!response) {
        console.log("error fetching profile");
        return {};
      }
      const data = response.data || {};
      return data;
    });
};

/**
 * Update Profile by user ID
 * @param id user ID
 * @returns Profile object
 */
const updateProfileById = (id: number, data: any) => {
  const client = new ApiService();
  const path = `/profiles/${id}`;

  client.setAuthHeader();
  return client.patch(path, data)
    .then(response => {
      if (!response) {
        console.log("error fetching profile");
        return {};
      }
      const data = response.data || {};
      return data;
    });
};

/**
 * Update address by ID
 * @param id ID
 * @returns updated address object
 */
 const updateAddressById = (id: number, data: any) => {
  const client = new ApiService();
  const path = `/addresses/${id}`;

  client.setAuthHeader();
  return client.patch(path, data)
    .then(response => {
      if (!response) {
        console.log("error fetching profile");
        return {};
      }
      const data = response.data || {};
      return data;
    });
};

/**
 * get address by id
 * @param userID -- userID --
 * @returns address fields
 */
 const getAddressById = (userId: number) => {
  const client = new ApiService();
  const path = `/addresses?userId=${userId}`;

  client.setAuthHeader();
  return client.get(path)
    .then(response => {
      if (!response) {
        console.log("error fetching profile");
        return {};
      }
      const data = response.data || {};
      return data;
    });
};
/**
 * create address for user
 */
const createUserAddress = (data: any) => {
  const client = new ApiService();
  const path = `/addresses`;

  client.setAuthHeader();
  return client.post(path, data)
    .then(response => {
      if (!response) {
        console.log("error creating user address");
      }
      const data = response.data || {};
      return data;
    })
};

const getUserById = (id: number) => {
  const client = new ApiService();
  const path = `/users/${id}`;

  client.setAuthHeader();
  return client.get(path)
    .then(response => {
      if (!response) {
        console.log("error fetching profile");
        return {};
      }
      const data = response.data || {};
      return data;
    });
};

export const userService = {
  getProfileById,
  getUserById,
  updateProfileById,
  getAddressById,
  createUserAddress,
  updateAddressById
};